<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

@for (controlModel of model; track trackByFn($index, controlModel)) {
  <dynamic-form-control
    [group]="group"
    [hidden]="controlModel.hidden"
    [layout]="layout"
    [model]="controlModel"
    [token]="token"
    (blur)="onBlur($event)"
    (change)="onChange($event)"
    (focus)="onFocus($event)"
    (metaDataSelectedEvent)="onMetadataSelected($event)"
  ></dynamic-form-control>
}
